











import Vue from "vue";

interface Data {
  activeTab: number | string | null;
}

interface Method{
  setTab(value: number): void;
}

interface Props{
  defaultTab: number;
}
export default Vue.extend<Data,Method,{},Props>({
  props: {
    defaultTab: Number,
  },

  beforeMount() {
    if (this.defaultTab) this.activeTab = this.defaultTab;
  },

  data: (): Data => ({
    activeTab: null,
  }),

  methods: {
    // Programozott fülváltás (pl. a kontír dim-szerkesztő a kijelölt tétel
    // első létező bontás-fülére ugrik)
    setTab(index: number) {
      this.activeTab = index;
    },
  },
});
